export default __webpack_public_path__ + "static/media/values2.bd866c10.png";